import { useState } from "react";
import { connect } from "react-redux";
import { Toaster } from "react-hot-toast";
import QueryString from 'query-string';
import PropTypes from 'prop-types';

import { createManyCases, getAllCases, resetRefinancingCases } from '../../../redux/actions/casesActions';
import RefinancingModal from "./RefinancingModal";

const RefinancingUpload = (props) => {
  const { createManyCases, resetRefinancingCases, getAllCases, manyCases, location, history } = props;
  const [showModal, setShowModal] = useState(false);

  const toggle = () => setShowModal(!showModal);

  const handleSubmit = (data) => {
    let query = QueryString.parse(location.search);
    createManyCases(data, (res) => {
      if (res.status === 201) {
        getAllCases(query, () => history.push(`/casos?${QueryString.stringify(query)}`));
        toggle();
      }
    })
  }

  return (
    <div >
      <Toaster />
      <RefinancingModal
        toggle={toggle}
        modal={showModal}
        handleSubmit={handleSubmit}
        resetRefinancingCases={resetRefinancingCases}
        manyCases={manyCases}
      />
      <button
        type="button"
        className="crm-black-btn"
        onClick={toggle}
      >
        + Carga Refinanciamiento
      </button>
    </div>
  )
}

RefinancingUpload.propTypes = {
  resetRefinancingCases: PropTypes.func,
  createManyCases: PropTypes.func,
  getAllCases: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
  manyCases: PropTypes.shape({
    response: PropTypes.any,
    loading: PropTypes.bool,
    error: PropTypes.array
  })
};

const mapStateToProps = ({ cases }) => ({
  manyCases: cases.manyCases,
});

const mapDispatchToProps = { createManyCases, getAllCases, resetRefinancingCases };

export default connect(mapStateToProps, mapDispatchToProps)(RefinancingUpload);